import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "apollo-link-context";
import { getCookie } from "./cookies";

// const httpLink = createHttpLink({
//     uri: process.env.REACT_APP_API_HOST,
// });

// const authLink = setContext((_, { headers }) => {
//     const token = getCookie("piap_jwt_token");

//     return {
//         headers: {
//             ...headers,
//             authorization: token ? `Bearer ${token}` : "",
//         },
//     };
// });

// export const apolloClient = new ApolloClient({
//     link: authLink.concat(httpLink),
//     cache: new InMemoryCache(),
// });

const uri = getCookie("piap_host_url");
const httpLink = createHttpLink({ uri });
const authLink = (token) =>
    setContext((_, { headers }) => ({
        headers: {
            ...headers,
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
    }));

export const graphQLClient = (token) => {
    const headerConfiguration = {
        headers: {
            authorization: `Bearer ${token}`,
        },
    };

    const cache = new InMemoryCache();

    return new ApolloClient({
        uri,
        cache,
        headers: headerConfiguration.headers,
    });
};

// export const graphQLRequest = new ApolloClient(getCookie("piap_host_url"), {
//     headers: {
//         Authorization: `Bearer ${getCookie("piap_jwt_token")}`,
//     },
//     cache: new InMemoryCache(),
// });

export default (token) =>
    new ApolloClient({
        link: authLink(token).concat(httpLink),
        cache: new InMemoryCache(),
    });

export const noAuthClient = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
});

// export const graphQLClient = new GraphQLClient(uri,configuredToken);

export const UserStatusEnum = {
    Active: 1,
    Pending: 2,
    Inactive: 0,
    NotVerified: 3,
    NotApproved: 5,
    NotVerifiedManual: 7,
    Rejected: 9,
    "Forgot Password": 4,
};

export const UserStatusEnumForEcxal = {
    1: "Active",
    2: "Pending",
    0: "Inactive",
    3: "Email Not Verified",
    5: "NotApproved",
    7: "Registration Pending",
    9: "Rejected",
    4: "Forgot Password",
};

export const UserStatusObj = {
    1: "Active",
    2: "Pending",
    0: "Inactive",
    3: "Email Not Verified",
    5: "Not Approved",
    7: "Registration Pending",
    9: "Rejected",
    4: "Forgot Password",
};

// list for Route Authontication
export const applicationList = {
    DERMARISE: "abbvie_dermrise",
    SEA: "abbvie_sea",
    INFOCENTER: "infocenter",
    ABBVIEPRO: "abbvie_pro",
    ABBVIELMBC: "abbvie_lmbc",
    ABBVIEPROFORMS: "abbvie_pro_forms",
    ALLERGANPRO: "allergan_pro",
    ALLERGANPROFORMS: "allergan_pro_forms",
    ABBVIEPROGROUPSPECIALTIES: "abbvie_pro_group_specialties",
    BASIC_LOGIN: "basic_login",
};

export const countryList = {
    ITALY: "IT",
    FRANCE: "FR",
};

export const userType = {
    SUPER_ADMIN: 99,
    APP_ADMIN: 1,
    READ_ONLY: 2,
    BASIC_LOGIN_USER: 14,
    BASIC_LOGIN_ADMIN: 19,
    USER_MANAGER: 3,
};
// Admin User Type for view
export const adminUserType = {
    99: "System Admin",
    1: "Site Admin",
    19: "Basic Login Admin",
    3: "User Manager",
};

export const userTypeList = [
    {
        id: 3,
        name: "User Manager",
    },
    {
        id: 1,
        name: "Site Admin",
    },
    {
        id: 2,
        name: "Read Only Admin",
    },
    {
        id: 0,
        name: "HCP User",
    },
];

// list for Super Admin
export const applicationData = [
    {
        applicationId: "abbvie_pro",
        applicationName: "Abbvie Pro",
    },
    {
        applicationId: "abbvie_pro_training",
        applicationName: "Abbvie Pro Training",
    },
    {
        applicationId: "abbvie_pro_medical",
        applicationName: "Abbvie Pro Medical",
    },
    {
        applicationId: "abbvie_lmbc",
        applicationName: "Abbvie LMBC",
    },
    {
        applicationId: "allergan_pro",
        applicationName: "Allergan Pro",
    },
    {
        applicationId: "allergan_pro_ami",
        applicationName: "Allergan pro Ami",
    },
];

// Basic Login Application
export const basicLoginApplicationList = [
    {
        applicationId: "abbvie_pro",
        applicationName: "Abbvie Pro",
    },
    {
        applicationId: "abbvie_pro_medical",
        applicationName: "Abbvie Pro Medical",
    },
    {
        applicationId: "abbvie_pro_training",
        applicationName: "Abbvie Pro Training",
    },

    {
        applicationId: "allergan_pro_ami",
        applicationName: "Abbvie Pro AMI",
    },
    {
        applicationId: "abbvie_lmbc",
        applicationName: "Abbvie LMBC",
    },

    {
        applicationId: "abbvie_lets_talk_eczema_ous",
        applicationName: "Abbvie Lets Talk Eczema",
    },
    {
        applicationId: "abbvie_talkoverra_ous",
        applicationName: "Abbvie Talkoverra",
    },
    {
        applicationId: "abbvie_skyrizi",
        applicationName: "Abbvie Skyrizi",
    },
    {
        applicationId: "abbvie_skyrizi_me",
        applicationName: "Abbvie Skyrizi ME",
    },
    {
        applicationId: "abbvie_rinvoq",
        applicationName: "Abbvie Rinvoq",
    },
    {
        applicationId: "abbvie_rinvoq_me",
        applicationName: "Abbvie Rinvoq ME",
    },
    {
        applicationId: "abbvie_infocenter",
        applicationName: "Abbvie Infocenter",
    },
    {
        applicationId: "allergan_pro",
        applicationName: "Allergan Pro",
    },
    {
        applicationId: "infocenter_rheuma",
        applicationName: "Infocenter Rheuma",
    },
    {
        applicationId: "infocenter_gastro",
        applicationName: "Infocenter Gastro",
    },
    {
        applicationId: "skyrizi_de",
        applicationName: "Skyrizi DE",
    },

    {
        applicationId: "tale_of_two_patients",
        applicationName: "Tale of Two Patients",
    },
    {
        applicationId: "optive",
        applicationName: "Optive",
    },
    {
        applicationId: "xen_implantat",
        applicationName: "Xen Implantat",
    },
    {
        applicationId: "abbvie_care_ous",
        applicationName: "Abbvie Care",
    },
    {
        applicationId: "arzneimittelsuche",
        applicationName: "Arzneimittelsuche",
    },
    {
        applicationId: "skyrizi",
        applicationName: "Skyrizi",
    },
    {
        applicationId: "meinparkinson",
        applicationName: "Meinparkinson",
    },
    {
        applicationId: "healthcareheroes",
        applicationName: "Healthcareheroes",
    },
    {
        applicationId: "abbvie_pro_acuiti",
        applicationName: "Abbvie Pro ACUITI",
    },
    {
        applicationId: "yasamlardaizbirak",
        applicationName: "Yasamlardaizbirak",
    },
    {
        applicationId: "support_center",
        applicationName: "Support Center",
    },
    {
        applicationId: "demo",
        applicationName: "Sitegenarator",
    },
    {
        applicationId: "dry-eye",
        applicationName: "Dry Eye",
    },
    {
        applicationId: "acne-inversa",
        applicationName: "Acne Inversa",
    },
    {
        applicationId: "sagliginicinkesfet",
        applicationName: "Sagliginicinkesfet",
    },
];

// list for site Admin
export const applicationName = {
    abbvie_pro: "Abbvie Pro",
    abbvie_lmbc: "Abbvie LMBC",
    abbvie_pro_forms: "Abbvie Pro Forms",
    abbvie_pro_group_specialties: "Abbvie Pro Group Specialties",
    allergan_pro_forms: "Allergan Pro Forms",
    allergan_pro: "Allergan Pro",
    basic_login: "Basic Login",
};

export const appListKeyRename = (id, name) => {
    const newAppList = [];
    const _basicLoginApplicationList = basicLoginApplicationList.sort((a, b) =>
        a.applicationId.localeCompare(b.applicationId)
    );
    _basicLoginApplicationList.map((item) => {
        const obj = {};
        obj[id] = item.applicationId;
        obj[name] = item.applicationName;
        newAppList.push(obj);
        return obj;
    });

    return newAppList;
};

export const appListArrToObj = (arr, id, name) => {
    const obj = {};

    arr.map((item) => (obj[item[id]] = item[name]));

    return obj;
};

export const isConfirm = "confirm";
export const reqiuredMessage = " Required *";

export const passwordValidationMessage = " The password must be at least 8 characters long.";
export const passwordValidationMessagePro = " The password must be at least 6 characters long.";
// export const emailPattern ="^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|\"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?\")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$"
export const emailRegex =
    /^([a-zA-Z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-zA-Z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\\x01-\\x08\\x0b\\x0c\\x0d\\x7f]|[^\0-\x7f]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-zA-Z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][A-Za-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/;
export const proActivationUrl =
    process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_PRO_APPROVAL_PATH_URL;
export const proSpecialityUrl =
    process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_PRO_SPECIALITY;
export const passwordRegex =
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-={}[\]\\|;:',.?/`~><""])[a-zA-Z0-9!@#$%^&*()_+\-={}[\]\\|;:',.?/`~><""]{8,}$/;

export const errorMessages = {
    samlErr: "Your Account is Inactive. Please contact with administrator",
};
